<span *ngIf="header" class="field-header" >{{header}}</span> 
<p *ngIf="headerSuccessText" class="m-0 p-0 success-tip" [innerHTML]="headerSuccessText" ></p>
<mat-form-field  
style="width: 100%;"
[ngClass]="header ? 'mt-2' : ''"
[appearance]="appearance">
  <mat-label>{{ label }}</mat-label>
  <input 
  matInput 
  [matDatepicker]="picker"
  [placeholder]="label ? label : 'Date'" 
  [formControl]="controlName" 
  />
  <!-- <mat-hint>MM/DD/YYYY</mat-hint> -->
  <mat-datepicker-toggle matIconSuffix [for]="picker">
    <mat-icon matDatepickerToggleIcon color="primary" *ngIf="!hasError() && !isValid()">calendar_today</mat-icon>
    <mat-icon matDatepickerToggleIcon *ngIf="hasError()" color="warn">info</mat-icon>
    <mat-icon matDatepickerToggleIcon *ngIf="isValid()"  class="icon-success">check_circle</mat-icon>
  </mat-datepicker-toggle>  
  <mat-datepicker #picker></mat-datepicker>
  <mat-error *ngIf="hasError()">{{ getErrorMessage() }}</mat-error>
</mat-form-field>
